import { useEffect, useRef, useState } from "react";

/**
 * Hook personalizado para detectar se um texto está sendo truncado
 * @returns ref e isTruncated
 */
export function useTruncatedText() {
  const ref = useRef<HTMLElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      if (ref.current) {
        const element = ref.current;
        // Verifica se o texto está sendo truncado comparando scrollWidth com clientWidth
        const truncated = element.scrollWidth > element.clientWidth;
        setIsTruncated(truncated);
      }
    };

    // Verifica inicialmente
    checkTruncation();

    // Adiciona listener para redimensionamento da janela
    window.addEventListener("resize", checkTruncation);

    // Usa ResizeObserver se disponível para detectar mudanças no elemento
    let resizeObserver: ResizeObserver | null = null;
    if (window.ResizeObserver && ref.current) {
      resizeObserver = new ResizeObserver(checkTruncation);
      resizeObserver.observe(ref.current);
    }

    return () => {
      window.removeEventListener("resize", checkTruncation);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, []);

  return { ref, isTruncated };
}
